import { SectionCard } from '@/components/ui/SectionCard';
import { useI18n } from '@/hooks/useI18n';
import { RequestForm } from './components/RequestForm';
import { RequestsTable } from './components/RequestsTable';

const RequestsPage = () => {
  const { t } = useI18n();

  return (
    <section className="dashboard">
      <div className="dashboard-inner">
        <header className="dashboard-head">
          <div>
            <p className="breadcrumbs">{t('drawer.group.requests')}</p>
            <h2>{t('dashboard.requestsTitle')}</h2>
          </div>
        </header>

        <div className="full-grid">
          <SectionCard title={t('dashboard.requestsTitle')} span={12}>
            <RequestsTable />
          </SectionCard>
          <SectionCard title={t('requests.form.title')} hint={t('requests.form.hint')} span={12}>
            <RequestForm />
          </SectionCard>
        </div>
      </div>
    </section>
  );
};

export default RequestsPage;
